export class LocalStorage {
    constructor(namespace) {
        this.namespace = namespace;
    }
    set(key, value) {
        localStorage.setItem(`${this.namespace}.${key.toString()}`, value.toString());
    }
    get(key) {
        return localStorage.getItem(`${this.namespace}.${key.toString()}`);
    }
    getOrElse(key, orElse) {
        return this.isSet(key) ? this.get(key) : orElse.toString();
    }
    isSet(key) {
        return localStorage.getItem(`${this.namespace}.${key.toString()}`) !== null;
    }
}
